export const useDeviceDimensions = () => {
  const fullHeight = window.innerHeight;
  const fullWidth = window.innerWidth;
  return { fullHeight, fullWidth };
};
